import React from 'react';

import style from './company.module.scss';

import { Intro } from './intro';
import { Contact } from './contact';

export const Company = () => {
    return (
        <div className={style.company}>
            <img
                alt=""
                src={process.env.PUBLIC_URL + '/assets/image/footer/logo-footer.png'}
                className={style.companyLogo}
            ></img>

            <div className={style.companyInfoContainer}>
                <div className={style.companyInfoItem}>
                    <Intro></Intro>
                </div>

                <div className={style.companyInfoItem}>
                    <Contact></Contact>
                </div>
            </div>
        </div>
    );
};
